import axios from 'axios';
import apiConfig from '../../api.config';

export default async function saveInvoiceSFTP(hotelId, atlasId, status, config) {
  const {
    host,
    URIs: { saveInvoiceSFTP },
  } = apiConfig;

  const uri = `${host}${saveInvoiceSFTP}`.replace(':hotelId', hotelId);
  const data = {
    atlasid: atlasId,
    status: status,
    civitfunid: hotelId,
    sftp_credentials: config,
  };

  return await axios
    .put(uri, data, {
      headers: { 'Content-Type': 'application/json' },
    })
    .then(res => res.data);
}
